import Big from 'big.js';

export function getLegacyDiscountedPrice({ discount, price }) {
  return discount
    ? new Big(price).minus(new Big(discount).div(100).times(price)).toNumber()
    : price;
}

